import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ng-business-meal-solution',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './meal-solution.component.html',
  styleUrls: ['./meal-solution.component.scss'],
})
export class MealSolutionComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) description: string;
}
